module.exports = __webpack_public_path__ + "img/chat-incoming-alt.dd8318cd.svg";